// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__-78q_","iconBox":"styles_iconBox__3WJxF"};